import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../../utils';

export const Logout_API_CALL = createAsyncThunk(
  'Logout_API_CALL',
  async (payload, { dispatch }) => {
    dispatch({ type: 'Logout_API_CALL/pending', payload: {} });

    const {
      customerId,
      Authorization,
      customerRefNum,
      source,
      successFn = null,
      errorFn = null,
      finallyFn = null,
    } = payload;
    // console.log(
    //   'Payload from logout api',
    //   customerId,
    //   Authorization,
    //   customerRefNum,
    //   source
    // );
    if (customerId && Authorization && customerRefNum && source) {
      SecureClient({
        isEncrypted: true,
        customerId,
        route: 'dashboardmenus/logout',
        payload: {
          customerRefNum,
          source,
          appId: APP_ID,
          appVersion: APP_VERSION,
        },
        otherPayloadDetailsPresent: true,
        headers: { Authorization },
        method: 'POST',
        successFn: (res) => {
          debug('WATCH', `Logout Response: `, res);
          if (successFn) successFn(res);
          dispatch({ type: 'Logout_API_CALL/fulfilled', payload: res });
        },
        errorFn: (err) => {
          debug('ERROR', `Error: `, err);
          if (errorFn) errorFn(err);
          dispatch({ type: 'Logout_API_CALL/rejected', payload: err });
        },
        finallyFn: () => {
          if (finallyFn) finallyFn();
        },
      });
    }
  }
);

export const Logout_API_CALL_extrareducer = {
  [Logout_API_CALL.pending]: (state, action) => {
    state.logoutAPICall.isLoading = true;
  },
  [Logout_API_CALL.fulfilled]: (state, action) => {
    state.logoutAPICall.isLoading = false;
    state.logoutAPICall.isSuccess = true;
    state.logoutAPICall.isError = false;
    state.firstName = '';
    state.lastName = '';
    state.logoutAPICall.response = action.payload;
  },
  [Logout_API_CALL.rejected]: (state, action) => {
    state.logoutAPICall.isLoading = false;
    state.logoutAPICall.isSuccess = false;
    state.logoutAPICall.isError = true;
    state.logoutAPICall.response = action.payload;
  },
};
